<template>
    <div class="white-box white-box-no-tab">
        <TermsFrame
            title="保險單借款"
            subtitle="為維護您的權益，保險單借款申請前，請詳細閱讀「保險單借款約定條款及重要事項告知」"
            btnText="本人已閱讀並同意"
            needLayer
            needGuideArrow
            :needBtn="isScrollToBottom"
            :content="content"
            :isLoading="isLoading"
            @isScrollToBottom="v => isScrollToBottom = v"
            @clickBtn="goNext"
        />
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAgreeTermsPon4300, postAgreePon4300 } from '@/apis/Pon4300.js';
import TermsFrame from '@/components/template/TermsFrame.vue';
import routeName from '@/router/constant.js';

export default {
    components: {
        TermsFrame,
    },
    setup() {
        const router = useRouter();
        const content = ref('');
        const isLoading = ref(false);
        const isScrollToBottom = ref(false);
        const getTerms = () => {
            getAgreeTermsPon4300().then(res => {
                if (res.data.agreeTerms) content.value = res.data.agreeTerms.content;
            });
        };
        getTerms();
        const goNext = () => {
            isLoading.value = true;
            postAgreePon4300().then(() => {
                router.push({ name: routeName.LOAN_TERM_TWO });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        return { goNext, content, isLoading, isScrollToBottom };
    },
};
</script>
